import getCityName from './getCityName'

const events = {
  sarov: {
    marketplace_sport_2: [ 47559253, 'reachGoal', 'marketplace_sport_2', ],
    marketplace_school_2: [ 47559253, 'reachGoal', 'marketplace_school_2' ],
    marketplace_abon_3: [ 47559253, 'reachGoal', 'marketplace_abon_3' ],
    marketplace_once_3: [ 47559253,'reachGoal','marketplace_once_3' ],
    marketplace_cancel_order_FIN: [ 47559253, 'reachGoal', 'marketplace_cancel_order_FIN' ],
    marketplace_cancel_food_order_FIN: [ 47559253, 'reachGoal', 'marketplace_cancel_food_order_FIN' ],
    marketplace_sport_FIN: [ 47559253, 'reachGoal', 'marketplace_sport_FIN' ],
    marketplace_school_FIN: [ 47559253, 'reachGoal', 'marketplace_school_FIN' ],
  },
}

// Yandex Metrika script
const ym = (event) => {
  const cityName = getCityName({ host: window.location.host })

  if (!events[cityName] || !events[cityName][event]) {
    return
  }

  if (typeof window.ym === 'function') {
    window.ym(...events[cityName][event])
    console.log(...events[cityName][event])
  }
  else {
    console.error('ym is not a function', ...events[cityName][event])
  }
}

export default ym
